<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />
          </el-select>
        </div>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <el-button type="primary" class="button-v2" @click="getData()">{{ $t('reflash') }}</el-button>
      </div>
      <div class="title-right">
        <span STYLE="font-size: 12px;color:#FF0000;">注意：当前功能仅为发薪前工资条条数据预览，发薪后您可以在「订单中心」预览准确的工资条数据。</span>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
        @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="unPaydetail(row)">{{ $t('viewDetails') }}</span>
          </div>
        </template>
      </air-table>

      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
    </div>


  </div>
</template>

<script>
  import * as api from '@/api/wage/payslip'
  import {queryEmpInfoListPage} from '@/api/v2/common'

  export default {
    name: 'UnpayBatchInfo',
    components: {

    },
    data() {
      return {
        loading: true,
        queryParams: {
          page: 1,
          limit: 20,
        },
        total: 0,
        columns: [
          {title: this.$t('wageMonth'), field: 'wageMonth', minWidth: 150, filterType: 'month'},
          {title: this.$t('batchNo'), field: 'id', minWidth: 150, filterType: 'input'},
          {title: this.$t('createTime'), field: 'bizCreateTime', minWidth: 150, filterType: 'daterange'},
          {title: this.$t('salesman'), field: 'yw', minWidth: 100, filterType: 'input'},
          {title: this.$t('payAmountTotal'), field: 'batchPayableAmount', minWidth: 100},
          {title: this.$t('actAmountTotal'), field: 'batchPayAccount', minWidth: 100},
        ],
        tableData: [],
        form: {},
        submitLoading: false,
        dictData: {
          emp: []
        },
        isSelectChange: false
      }
    },
    computed: {
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getEmpList()
        this.getData()
      },
      getData() {
        this.loading = true
        api.selectUnPayBatchInfo(this.queryParams).then(res => {
          if (res.data.data){
            this.tableData = res.data.data.dataList
            this.total = res.data.data.total
            this.queryParams.total = res.data.data.total
          }
          this.loading = false
        })
      },
      getEmpList() {
        queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
          this.dictData.emp = res.data.records
        })
      },
      handleSelectChange(val) {
        if (this.$isEmpty(val)) {
          // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
          this.getData()
          this.isSelectChange = false
        } else {
          this.isSelectChange = true
        }
      },
      handleSelectVisibleChange(val) {
        // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
        if (!val && this.isSelectChange) {
          this.getData()
          // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
          this.isSelectChange = false
        }
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData}
        this.getData()
      },
      unPaydetail(item) {
        this.$go('/payslip/unpayslippreview', {
          cusId: item.cusId,
          batchId: item.id,
          des: item.wageMonth.replace('-','年')+"月 - "+item.id,
        })
      },
      // 输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
